<div class="h-dvh flex flex-col overflow-hidden bg-app-background">
  @if (isWaiting()) {
    <app-session-waiting class="flex-1 min-h-0 w-full"></app-session-waiting>
  } @else if (isTerminated()) {
    <app-session-terminated class="flex-1 min-h-0 w-full"></app-session-terminated>
  } @else {
    <app-mib-header class="shrink-0 w-full"></app-mib-header>

    @if (isReady()) {
      @if (state.isSmall()) {
        <main class="flex-1 overflow-y-auto" [attr.aria-label]="mainAriaLabel()">
          @switch (state.currentSmallView()) {
            @case ('video') {
              <app-video-tab></app-video-tab>
            }
            @case ('chat') {
              <app-chat-tab></app-chat-tab>
            }
          }
        </main>
        <mai-footer-action-bar class="shrink-0">
          <mai-smartphone-button
            [active]="state.currentSmallView() === 'video'"
            (click)="state.currentSmallView.set('video')"
          >
            <svg mib-video-icon></svg>
            Live
          </mai-smartphone-button>
          <mai-smartphone-button
            [active]="state.currentSmallView() === 'chat'"
            (click)="state.currentSmallView.set('chat')"
          >
            <svg mib-message-circle-icon></svg>
            Chat Ai
          </mai-smartphone-button>
        </mai-footer-action-bar>
      } @else {
        <main
          class="flex flex-1 min-h-0 gap-6 p-6 max-lg:landscape:p-3"
          [attr.aria-label]="mainAriaLabel()"
        >
          <app-video-tab [class]="videoTabClasses()"></app-video-tab>
          <app-chat-tab [class]="chatTabClasses()"></app-chat-tab>
        </main>
      }
    } @else {
      <mib-spinner overlay="" size="large">
        <span class="text-center text-[33px] font-normal leading-tight text-[#102753]"
          >Connecting <br />to the session …</span
        >
      </mib-spinner>
    }
  }
</div>
